import {yupNumber} from 'shared/web';

import i18n from '../../../i18n/i18n';

const POWER_MIN = 10;
const POWER_MAX = 650;

export function buildPowerValidation(allowedPowerValues: number[]) {
  return yupNumber
    .integer(i18n.t('page.create.validation.powerMustBeInteger'))
    .min(POWER_MIN, ({min}) => i18n.t('page.create.validation.powerMustBeMin', {min}))
    .max(POWER_MAX, ({max}) => i18n.t('page.create.validation.powerMustBeMax', {max}))
    .required()
    .oneOf(allowedPowerValues, (params: {value?: number}) =>
      i18n.t('page.create.validation.powerMustBeOneOfOptions', {
        value: params.value ?? '',
      })
    );
}
